import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SiteSelectionState {
  selectedSiteId: string | null;
  setSelectedSiteId: (id: string | null) => void;
}

export const useSiteSelectionStore = create<SiteSelectionState>()(
  persist(
    (set) => ({
      selectedSiteId: null,
      setSelectedSiteId: (id) => set({ selectedSiteId: id }),
    }),
    { name: 'square-iso.site-selection' },
  ),
);
